import { Box } from '@chakra-ui/react';
import parseUrl from 'parse-url';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import YouTube from 'react-youtube';

interface Props {
  videoUrl: string;
}

const EventDetailVideo: FC<Props> = ({ videoUrl }) => {
  const { t } = useTranslation();

  const parsedUrl = parseUrl(videoUrl);

  return (
    <>
      <GridHeading>{t('videoFromEvent')}</GridHeading>
      <Box w="100%" borderRadius="16px" overflow="hidden">
        <YouTube
          videoId={parsedUrl.query['v']}
          opts={{
            width: '100%',
            height: '362px',
          }}
        />
      </Box>
    </>
  );
};

export default EventDetailVideo;
